import React, { useState } from "react";
import {
  Button,
  FlexRowBetween,
  GenericDiv,
  Input,
  Label,
  PopupForm,
  TextArea,
  FlexRowColumnBetween,
  TextWithPic,
  RespFont,
} from "../../common/Style";
import { useForm } from "react-hook-form";
import { CFV, getImageUrl } from "../../common/others/Functions";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  editDetails,
  seperationEvent,
} from "../../../store/reducers/authReducer";
import SketchColorPalette from "../others/SketchColorPalette";
import palette from "../../../assets/common/palette.svg";
import pdf1 from "../../../assets/common/pdf1.svg";
import infoS from "../../../assets/common/infoS.svg";
import tools from "../../../assets/common/menu.svg";
import logout from "../../../assets/common/logout.svg";
import gallery from "../../../assets/common/gallery.svg";
import InvitationDemo from "./InvitationDemo";
import FilterBar from "../others/FilterBar";
import Image from "./Image";
import GenericModal from "../modals/GenericModal";
import LogoutSpecipic from "../LogOut/LogoutSpecipic";
import ToolsOptions from "../../user/ToolsOptions";
import { useHistory } from "react-router-dom";
import ClientRoutes from "../../../navigation/Routes";
import BottomMenu from "../others/BottomMenu";
import YesNoModal from "../modals/YesNoModal";

const EditPage = () => {
  const [showGifts, setShowGifts] = useState(false);

  let history = useHistory();
  let categories = [
    { id: "עליון", name: "עליון" },
    { id: "כפתור", name: "כפתור" },
    { id: "תחתון", name: "תחתון" },
  ];
  const [category, setCategory] = useState("כפתור");
  const { user, isTal } = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();

  const is180dealTextField = register("is180dealText", {
    minLength: 0,
    validate: (v) =>
      !v || !/[,\n\r]/.test(v) || "אין להשתמש בפסיק או בירידת שורה",
  });

  const [view, setView] = useState(false); // 1 for details, 2 for pic
  let pic = "";
  pic =
    user?.pic !== ""
      ? `${getImageUrl().replace('"', "")}${user._id}/${user.pic}`
      : `${getImageUrl()}sys/defaultInvPic.jpeg`;
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const [specialDishes, setSpecialDishes] = useState(user.specialDishes);
  const [inv, setInv] = useState(user.eventType ? user.inv : 2);
  const [invK, setInvK] = useState(user.invK);
  const [centeredPic, setCenteredPic] = useState(user.centeredPic);
  const [separation, setSeparation] = useState(user.separation);
  const [seuda, setSeuda] = useState(user.seuda);
  const [family, setFamily] = useState(user.family);
  const [cropAreaAspect, setCropAreaAspect] = useState(user.cropAreaAspect);
  const [picPosition, setPicPosition] = useState(user.picPosition);
  const [transportation, setTransportation] = useState(user.transportation);
  const [specialMsg, setSpecialMsg] = useState(user.specialMsg);
  const [is180deal, setIs180deal] = useState(user.is180deal);
  const [blessing, setBlessing] = useState(user.blessing);
  const [topColor, setTopColor] = useState(user.gradient[0]);
  const [bottomColor, setBottomColor] = useState(user.gradient[1]);
  const [heartColor, setHeartColor] = useState(user.heartColor);
  const [showLogout, setShowLogout] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  let color2changeDict = {
    עליון: [topColor, setTopColor],
    כפתור: [heartColor, setHeartColor],
    תחתון: [bottomColor, setBottomColor],
  };

  const handleSetSpecialDishes = () => {
    setSpecialDishes(!specialDishes);
  };

  const handleSetBlessing = () => {
    setBlessing(!blessing);
  };

  const handlesetIs180deal = () => {
    setIs180deal(!is180deal);
  };

  const handlesetSpecialMsg = () => {
    setSpecialMsg(!specialMsg);
  };

  const handleSetTransportation = () => {
    setTransportation(!transportation);
  };

  const copyDetailsToClipboard = () => {
    const values = getValues();
    const lines = user.eventType
      ? [
          `שם פרטי - כלה: ${values.brideFN || ""}`,
          `שם פרטי - חתן: ${values.groomFN || ""}`,
          `שם משפחה - כלה: ${values.brideLN || ""}`,
          `שם משפחה - חתן: ${values.groomLN || ""}`,
          `הורי הכלה: ${values.brideParents || ""}`,
          `הורי החתן: ${values.groomParents || ""}`,
          `קבלת פנים: ${values.hour1 || ""}`,
          `חופה וקידושין: ${values.hour2 || ""}`,
          `אולם: ${values.hall || ""}`,
          `עיר: ${values.city || ""}`,
          `כתובת: ${values.address || ""}`,
        ]
      : [
          `תיאור האירוע: ${values.calendarName || ""}`,
          `קבלת פנים: ${values.hour1 || ""}`,
          `אולם: ${values.hall || ""}`,
          `עיר: ${values.city || ""}`,
          `כתובת: ${values.address || ""}`,
        ];
    const text = lines.join("\n");
    navigator.clipboard
      .writeText(text)
      .then(() => toast.success("הפרטים הועתקו ללוח – אפשר להדביק בווצאפ"))
      .catch(() => toast.error("ההעתקה נכשלה"));
  };

  const handleSetSeuda = () => {
    setSeuda(!seuda);
  };

  const handleSetSeparation = () => {
    setSeparation(!separation);
  };

  const handleSetFamily = () => {
    setFamily(!family);
  };

  const handleSetInvK = () => {
    if (invK === 2) setInvK(1);
    else setInvK(invK + 1);
  };

  const handleSetInv = () => {
    if (inv === 1) setInv(2);
    else setInv(1);
  };

  const onSubmit = async (data) => {
    const body = {
      brideFN: user.eventType ? data.brideFN : "",
      groomFN: user.eventType ? data.groomFN : "",
      brideLN: user.eventType ? data.brideLN : "",
      groomLN: user.eventType ? data.groomLN : "",
      brideParents: user.eventType ? data.brideParents : "",
      transportation,
      specialMsg,
      blessing,
      blessTitle: blessing ? (data.blessTitle ?? user.blessTitle ?? "") : "",
      separation,
      seuda,
      specialDishes,
      groomParents: user.eventType ? data.groomParents : "",
      transportationDetails: data.transportationDetails,
      specialMsgDetails: data.specialMsgDetails,
      is180dealText: String(data.is180dealText ?? "")
        .replace(/[,\n\r]/g, "")
        .trim(),
      is180deal,
      hall: data.hall,
      city: data.city,
      hour1: data.hour1,
      hour2: data.hour2 ? data.hour2 : data.hour1,
      address: data.address,
      inv,
      invK,
      waze: data.waze,
      gradient: [topColor, bottomColor],
      family,
      heartColor,
      picPosition,
      cropAreaAspect,
      calendarName: user.eventType ? "" : data.calendarName,
    };
    dispatch(editDetails(body)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
      } else toast.error(res.payload?.error);
    });
  };

  const handleSeperatEvent = () => {
    dispatch(seperationEvent({ uid: user._id })).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
      } else toast.error(res.payload?.error);
    });
  };

  return (
    <FlexRowColumnBetween style={{ padding: "20px" }}>
      <BottomMenu
        data={[
          <img
            key={1}
            src={tools}
            alt="tools"
            style={{ width: "31px", padding: "10px 0", cursor: "pointer" }}
            onClick={() => setShowMenu(true)}
          />,
          <img
            key={2}
            src={logout}
            alt="logout"
            style={{ width: "31px", padding: "10px 0", cursor: "pointer" }}
            onClick={() => setShowLogout(true)}
          />,
        ]}
      />

      {showLogout && (
        <GenericModal
          init={setShowLogout}
          div={<LogoutSpecipic init={setShowLogout} />}
        />
      )}

      {showMenu && (
        <GenericModal
          init={setShowMenu}
          div={
            <ToolsOptions
              data={[
                <TextWithPic
                  key={1}
                  onClick={() => history.push(ClientRoutes.User.main)}
                >
                  מוזמנים
                </TextWithPic>,
                <TextWithPic
                  onClick={() => history.push(ClientRoutes.User.instruction)}
                  key={2}
                >
                  הדרכות
                </TextWithPic>,
                <TextWithPic
                  onClick={() => history.push(ClientRoutes.User.todos)}
                  key={3}
                >
                  לו״ז
                </TextWithPic>,
              ]}
            />
          }
        />
      )}

      <PopupForm
        style={{ margin: "50px auto", zIndex: "1", maxHeight: "800px" }}
        onClick={(e) => e.stopPropagation()}
        onSubmit={handleSubmit(onSubmit)}
        className="animate__animated animate__fadeIn"
      >
        {view ? (
          <div
            className="animate__animated animate__fadeIn"
            style={{ width: "100%" }}
          >
            <Image
              pic={pic}
              setView={setView}
              setPicPosition={setPicPosition}
              setCropAreaAspect={setCropAreaAspect}
            />
          </div>
        ) : (
          <div
            style={{
              width: "90%",
              margin: "15px auto",
            }}
          >
            {!user.eventType && (
              <div style={{ marginBottom: "10px" }}>
                <Label>תיאור האירוע</Label>
                <Input
                  defaultValue={user.calendarName}
                  type="text"
                  {...register("calendarName", {
                    required: true,
                    minLength: 2,
                    maxLength: 200,
                  })}
                />
                {CFV("calendarName", "בין 2 ל 200 תווים", errors)}
                {/* <Input
                  disabled={true}
                  defaultValue={user.calendarName}
                  type="text"
                /> */}
              </div>
            )}
            {user.eventType && (
              <>
                <FlexRowBetween>
                  <div style={{ width: "40%" }}>
                    <Label>שם פרטי - כלה</Label>
                    <Input
                      defaultValue={user.brideFN}
                      type="text"
                      {...register("brideFN", {
                        required: true,
                        minLength: 2,
                        maxLength: 20,
                      })}
                    />
                    {CFV("brideFN", "בין 2 ל 20 תווים", errors)}
                  </div>

                  <div style={{ width: "40%" }}>
                    <Label>שם פרטי - חתן</Label>
                    <Input
                      defaultValue={user.groomFN}
                      type="text"
                      {...register("groomFN", {
                        required: true,
                        minLength: 2,
                        maxLength: 20,
                      })}
                    />
                    {CFV("groomFN", "בין 2 ל 20 תווים", errors)}
                  </div>
                </FlexRowBetween>
                <FlexRowBetween>
                  <div style={{ width: "40%" }}>
                    <Label>שם משפחה - כלה</Label>
                    <Input
                      defaultValue={user.brideLN}
                      type="text"
                      {...register("brideLN", {
                        required: true,
                        minLength: 2,
                        maxLength: 20,
                      })}
                    />
                    {CFV("brideLN", "בין 2 ל 20 תווים", errors)}
                  </div>

                  <div style={{ width: "40%" }}>
                    <Label>שם משפחה - חתן</Label>
                    <Input
                      defaultValue={user.groomLN}
                      type="text"
                      {...register("groomLN", {
                        required: true,
                        minLength: 2,
                        maxLength: 20,
                      })}
                    />
                    {CFV("groomLN", "בין 2 ל 20 תווים", errors)}
                  </div>
                </FlexRowBetween>
                <FlexRowBetween>
                  <div style={{ width: "47.5%" }}>
                    <Label>הורי הכלה</Label>
                    <Input
                      defaultValue={user.brideParents}
                      type="text"
                      {...register("brideParents", {
                        required: true,
                        minLength: 2,
                        maxLength: 50,
                      })}
                    />
                    {CFV("brideParents", "בין 2 ל 50 תווים", errors)}
                  </div>

                  <div style={{ width: "47.5%" }}>
                    <Label>הורי החתן</Label>
                    <Input
                      defaultValue={user.groomParents}
                      type="text"
                      {...register("groomParents", {
                        required: true,
                        minLength: 2,
                        maxLength: 50,
                      })}
                    />
                    {CFV("groomParents", "בין 2 ל 50 תווים", errors)}
                  </div>
                </FlexRowBetween>
              </>
            )}
            <FlexRowBetween>
              <div style={{ width: "40%" }}>
                <Label>קבלת פנים</Label>
                <Input
                  type={"time"}
                  style={{ paddingLeft: "5px" }}
                  defaultValue={user.hour1}
                  {...register("hour1", {
                    required: true,
                  })}
                />
                {CFV("hour1", "יש לבחור שעה", errors)}
              </div>
              {user.eventType && (
                <div style={{ width: "40%" }}>
                  <Label>חופה וקידושין</Label>
                  <Input
                    type={"time"}
                    style={{ paddingLeft: "5px" }}
                    defaultValue={user.hour2}
                    {...register("hour2", {
                      required: true,
                    })}
                  />
                  {CFV("hour2", "יש לבחור שעה", errors)}
                </div>
              )}
            </FlexRowBetween>
            <FlexRowBetween>
              <div style={{ width: "30%" }}>
                <Label>אולם</Label>
                <Input
                  defaultValue={user.hall}
                  type="text"
                  {...register("hall", {
                    required: true,
                    minLength: 2,
                    maxLength: 50,
                  })}
                />
                {CFV("hall", "בין 2 ל 50 תווים", errors)}
              </div>

              <div style={{ width: "30%" }}>
                <Label>עיר</Label>
                <Input
                  defaultValue={user.city}
                  type="text"
                  {...register("city", {
                    required: true,
                    minLength: 2,
                    maxLength: 50,
                  })}
                />
                {CFV("city", "בין 2 ל 50 תווים", errors)}
              </div>

              <div style={{ width: "30%" }}>
                <Label>כתובת</Label>
                <Input
                  defaultValue={user.address}
                  type="text"
                  {...register("address", {
                    required: true,
                    minLength: 2,
                    maxLength: 50,
                  })}
                />
                {CFV("address", "בין 2 ל 50 תווים", errors)}
              </div>
            </FlexRowBetween>
            <FlexRowBetween>
              <div style={{ width: "100%" }}>
                <Label>ניווט</Label>
                <Input
                  defaultValue={user.waze}
                  type="text"
                  {...register("waze", {
                    required: true,
                    minLength: 2,
                    maxLength: 50,
                  })}
                />
                {CFV("waze", "בין 2 ל 50 תווים", errors)}
              </div>
              <a
                href={`${getImageUrl()}sys/waze.pdf`}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={pdf1}
                  alt="pdf1"
                  style={{ width: "35px", marginRight: "20px" }}
                />
              </a>
            </FlexRowBetween>
            <FlexRowBetween>
              <div style={{ width: "100%" }}>
                <Label>מתנה באשראי</Label>
                <Input defaultValue={user.paybox} disabled={true} />
                <div style={{ height: "20px" }} />
              </div>
              <img
                onClick={() => {
                  if (user.paybox === "") setShowGifts(true);
                  else toast.info("הלינק כבר הופק ✔️");
                }}
                src={infoS}
                alt="infoS"
                style={{ width: "35px", marginRight: "20px" }}
              />
            </FlexRowBetween>
            {transportation && (
              <FlexRowBetween style={{ marginTop: "15px" }}>
                <div style={{ width: "100%" }}>
                  <Label>פרטי הסעה</Label>
                  <TextArea
                    defaultValue={user.transportationDetails}
                    type="text"
                    rows={3}
                    {...register("transportationDetails", {
                      minLength: 0,
                      maxLength: 500,
                    })}
                  />
                  {CFV("transportationDetails", "עד 500 תווים", errors)}
                </div>
              </FlexRowBetween>
            )}
            {specialMsg && (
              <FlexRowBetween style={{ marginTop: "15px" }}>
                <div style={{ width: "100%" }}>
                  <Label>פרטי הודעה</Label>
                  <TextArea
                    defaultValue={user.specialMsgDetails}
                    type="text"
                    rows={3}
                    {...register("specialMsgDetails", {
                      minLength: 0,
                      // maxLength: 500,
                    })}
                  />
                  {CFV("specialMsgDetails", "", errors)}
                </div>
              </FlexRowBetween>
            )}
            {is180deal && (
              <FlexRowBetween style={{ marginTop: "15px" }}>
                <div style={{ width: "100%" }}>
                  <Label>טקסט תוספת לתזכורת</Label>
                  <Input
                    defaultValue={String(user.is180dealText || "").replace(
                      /[,\n\r]/g,
                      "",
                    )}
                    type="text"
                    name={is180dealTextField.name}
                    ref={is180dealTextField.ref}
                    onBlur={is180dealTextField.onBlur}
                    onChange={(e) => {
                      const cleaned = e.target.value.replace(/[,\n\r]/g, "");
                      if (cleaned !== e.target.value) {
                        e.target.value = cleaned;
                      }
                      return is180dealTextField.onChange(e);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "," || e.key === "Enter") {
                        e.preventDefault();
                      }
                    }}
                  />
                  {CFV(
                    "is180dealText",
                    "טקסט קצר ללא פסיק וללא ירידת שורה",
                    errors,
                  )}
                </div>
              </FlexRowBetween>
            )}
            <FlexRowBetween style={{ marginTop: "15px" }}>
              <TextWithPic
                onClick={handleSetTransportation}
                style={{
                  padding: "5px 8px",
                  fontSize: "14px",
                  textDecoration: transportation ? "none" : "line-through",
                  boxShadow: transportation
                    ? "0 2px 4px #7b96c4"
                    : "0 2px 4px silver",
                }}
              >
                הסעה
              </TextWithPic>
              {isTal && (
                <TextWithPic
                  onClick={handlesetIs180deal}
                  style={{
                    padding: "5px 8px",
                    fontSize: "14px",
                    textDecoration: is180deal ? "none" : "line-through",
                    boxShadow: is180deal
                      ? "0 2px 4px #7b96c4"
                      : "0 2px 4px silver",
                  }}
                >
                  תוספת לתזכורת
                </TextWithPic>
              )}
              {user.eventType && (
                <TextWithPic
                  onClick={handleSetFamily}
                  style={{
                    padding: "5px 8px",
                    fontSize: "14px",
                    textDecoration: !family ? "none" : "line-through",
                    boxShadow: !family
                      ? "0 2px 4px #7b96c4"
                      : "0 2px 4px silver",
                    width: "max-content",
                  }}
                >
                  שמות הורים
                </TextWithPic>
              )}
              {user.eventType && (
                <TextWithPic
                  onClick={handleSetInv}
                  style={{
                    padding: "5px 8px",
                    fontSize: "14px",
                    textDecoration: inv === 1 ? "none" : "line-through",
                    boxShadow:
                      inv === 1 ? "0 2px 4px #7b96c4" : "0 2px 4px silver",
                  }}
                >
                  פרטים
                </TextWithPic>
              )}
            </FlexRowBetween>

            <FlexRowBetween style={{ marginTop: "20px" }}>
              <TextWithPic
                onClick={handleSetBlessing}
                style={{
                  padding: "5px 8px",
                  fontSize: "14px",
                  textDecoration: blessing ? "none" : "line-through",
                  boxShadow: blessing
                    ? "0 2px 4px #7b96c4"
                    : "0 2px 4px silver",
                }}
              >
                ברכות
              </TextWithPic>
              <TextWithPic
                onClick={handleSetSpecialDishes}
                style={{
                  padding: "5px 8px",
                  fontSize: "14px",
                  textDecoration: specialDishes ? "none" : "line-through",
                  boxShadow: specialDishes
                    ? "0 2px 4px #7b96c4"
                    : "0 2px 4px silver",
                  width: "max-content",
                }}
              >
                מנות מיוחדות
              </TextWithPic>
              <TextWithPic
                onClick={handleSetSeuda}
                style={{
                  padding: "5px 8px",
                  fontSize: "14px",
                  textDecoration: seuda ? "none" : "line-through",
                  boxShadow: seuda ? "0 2px 4px #7b96c4" : "0 2px 4px silver",
                  width: "max-content",
                }}
              >
                סעודה
              </TextWithPic>
              <TextWithPic
                onClick={handleSetSeparation}
                style={{
                  padding: "5px 8px",
                  fontSize: "14px",
                  textDecoration: separation ? "none" : "line-through",
                  boxShadow: separation
                    ? "0 2px 4px #7b96c4"
                    : "0 2px 4px silver",
                  width: "max-content",
                }}
              >
                הפרדה
              </TextWithPic>
            </FlexRowBetween>
            {blessing && (
              <FlexRowBetween style={{ marginTop: "15px" }}>
                <div style={{ width: "100%" }}>
                  <Label>כותרת ברכות</Label>
                  <TextArea
                    defaultValue={user.blessTitle}
                    type="text"
                    rows={3}
                    placeholder="ניתן להשאיר ברכה 🙂"
                    {...register("blessTitle", {
                      maxLength: 500,
                    })}
                  />
                  {CFV("blessTitle", "עד 500 תווים", errors)}
                </div>
              </FlexRowBetween>
            )}
            <FlexRowBetween style={{ marginTop: "20px" }}>
              <TextWithPic
                onClick={() => setView(!view)}
                style={{ width: "max-content" }}
              >
                <div>עריכת תמונה</div>
                <img
                  src={gallery}
                  alt="gallery"
                  style={{ width: "25px", marginRight: "20px" }}
                />
              </TextWithPic>
              <TextWithPic
                onClick={handlesetSpecialMsg}
                style={{
                  padding: "5px 8px",
                  fontSize: "14px",
                  textDecoration: specialMsg ? "none" : "line-through",
                  boxShadow: specialMsg
                    ? "0 2px 4px #7b96c4"
                    : "0 2px 4px silver",
                }}
              >
                הודעה
              </TextWithPic>
              <TextWithPic
                onClick={handleSetInvK}
                style={{
                  padding: "5px 8px",
                  fontSize: "14px",
                  boxShadow: "0 2px 4px #7b96c4",
                  width: "max-content",
                }}
              >
                {`סגנון ${invK}`}
              </TextWithPic>
            </FlexRowBetween>

            <FlexRowBetween style={{ marginTop: "15px" }}>
              <div>שינוי צבע: </div>
              <div
                style={{
                  width: "100%",
                  margin: "0 10px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                <FilterBar
                  data={categories}
                  setProperty={setCategory}
                  property={category}
                />
              </div>
              <div style={{ marginLeft: "0px" }}>
                <SketchColorPalette
                  color={color2changeDict[category][0]}
                  color2change={color2changeDict[category][1]}
                  display={displayColorPicker}
                  onClose={setDisplayColorPicker}
                  div={
                    <img
                      onClick={() => setDisplayColorPicker(!displayColorPicker)}
                      src={palette}
                      alt="palette"
                      style={{
                        width: "33px",
                        cursor: "pointer",
                        marginBottom: "-3px",
                      }}
                    />
                  }
                />
              </div>
            </FlexRowBetween>
            {!user.isReadyAdmin && (
              <Button
                type="button"
                onClick={copyDetailsToClipboard}
                style={{
                  width: "100%",
                  marginTop: "40px",
                  background: "transparent",
                  border: "2px solid rgba(41,59,90,0.95)",
                  color: "rgba(41,59,90,0.95)",
                }}
              >
                העתק פרטים לאישור (ווצאפ)
              </Button>
            )}
            {separation && (
              <Button
                type="button"
                onClick={handleSeperatEvent}
                style={{
                  width: "100%",
                  margin: "20px auto",
                  background: "transparent",
                  border: "2px solid rgba(41,59,90,0.95)",
                  color: "rgba(41,59,90,0.95)",
                }}
              >
                הפרדת כל האורחים לגברים ונשים
              </Button>
            )}
            <Button
              background={
                "linear-gradient(to right, rgba(41,59,90,0.95), rgba(123,150,196,0.95))"
              }
              style={{ width: "100%", marginTop: "10px" }}
              type="submit"
            >
              שמירה
            </Button>

            {showGifts && (
              <GenericModal
                init={setShowGifts}
                div={
                  <YesNoModal
                    title={"מתנות באשראי"}
                    body={
                      <div style={{ width: "100%" }}>
                        <RespFont csize={"20px"} psize={"18px"}>
                          {`עלות השירות: ${user.giftCost}`}
                        </RespFont>
                        <FlexRowBetween style={{ marginTop: "30px" }}>
                          <a
                            style={{ textDecoration: "none", width: "100px" }}
                            target="_blank"
                            rel="noreferrer"
                            href={`https://wa.me/972${user.pPhone}/?text=היי, ברצוני לקבל שירות מתנות באשראי לאירוע שלי, מספר הטלפון של אירוע זה הינו: ${user.phone}`}
                          >
                            <GenericDiv
                              style={{ height: "100px", width: "100px" }}
                            >
                              <div
                                style={{
                                  width: "min-content",
                                  height: "100px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                כמובן שאני רוצה
                              </div>
                            </GenericDiv>
                          </a>
                          <a
                            style={{ textDecoration: "none", width: "100px" }}
                            target="_blank"
                            rel="noreferrer"
                            href={`https://wa.me/972547439322/?text=היי, אשמח להבין יותר למה שירות מתנות באשראי הינו כל כך חשוב`}
                          >
                            <GenericDiv
                              style={{ height: "100px", width: "100px" }}
                            >
                              <div
                                style={{
                                  width: "min-content",
                                  height: "100px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                אשמח להבין את המשמעות
                              </div>
                            </GenericDiv>
                          </a>
                        </FlexRowBetween>
                      </div>
                    }
                    yesText={"אני טועה"}
                    noText={"אני טועה"}
                    no={setShowGifts}
                    yes={() => setShowGifts(false)}
                  />
                }
              />
            )}
          </div>
        )}
      </PopupForm>
      <InvitationDemo
        topColor={topColor}
        bottomColor={bottomColor}
        heartColor={heartColor}
        cropAreaAspect={cropAreaAspect}
        picPosition={picPosition}
      />
    </FlexRowColumnBetween>
  );
};

export default EditPage;
